/** 匿名 userId：首访生成一个随机 id 存 localStorage，随每个请求带 header。
 *  Slice 9 用它做额度账户主键；P1 换真登录时替换。 */

const KEY = 'avs-user-id';

function genId(): string {
  // u- 前缀 + 时间戳 + 随机，足够唯一（demo 级）
  const rand = Math.random().toString(36).slice(2, 10);
  const t = Date.now().toString(36);
  return `u-${t}${rand}`;
}

export function getUserId(): string {
  let id = '';
  try { id = localStorage.getItem(KEY) ?? ''; } catch { /* ignore */ }
  if (!id) {
    id = genId();
    try { localStorage.setItem(KEY, id); } catch { /* ignore */ }
  }
  return id;
}
